import type { DefaultTheme } from 'styled-components';
import { darkColors, mapDarkTheme } from './DarkTheme';

export const DarkTalosMobileTheme: DefaultTheme = mapDarkTheme(darkColors, {
  name: 'DarkTalosMobile',

  fontSizeInput: 1,

  fontSizeDefault: 1,
  fontSizeSmall: 0.875,
  fontSizeTiny: 0.75,
});
